import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { motion } from "framer-motion";
import { Reveal } from "@/components/common/Reveal";

export default function FinalCTA() {
  return (
    <section data-testid="final-cta" className="relative overflow-hidden bg-brand-charcoal text-white">
      <motion.img
        src="/gallery/img_7035.webp"
        alt="Freshly detailed car"
        initial={{ scale: 1.1 }}
        whileInView={{ scale: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 1.4, ease: "easeOut" }}
        className="absolute inset-0 h-full w-full object-cover opacity-25"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-brand-charcoal via-brand-charcoal/80 to-brand-charcoal/40" />
      <div className="container-rv relative z-10 py-28 lg:py-36">
        <Reveal>
          <p className="overline text-brand-red">Ready when you are</p>
          <h2 className="mt-5 max-w-3xl font-serif text-5xl font-bold leading-[1.02] sm:text-6xl lg:text-7xl">
            Your car could look like this by tonight.
          </h2>
          <p className="mt-6 max-w-lg text-brand-silver">
            Pick a day, we handle the rest. The pride of a spotless car is just 60 seconds away.
          </p>
          <div className="mt-9 flex flex-wrap gap-4">
            <Link to="/book" data-testid="final-cta-book-button" className="btn-red">
              Book Now <ArrowRight className="h-4 w-4" />
            </Link>
            <Link to="/pricing" className="inline-flex items-center justify-center gap-2 rounded-full border border-white/40 px-7 py-3.5 text-sm font-semibold text-white transition-colors duration-300 hover:bg-white hover:text-brand-charcoal">
              View Pricing
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
